import { STRATEGIES } from '../../constants';
/**
 * Get a flat de-duped list of all authentication method types contained in a strategies map/collection.
 */
export function getAuthMethodTypesForStrategyMap(strategiesMap) {
    const authenticationMethodTypes = Object.values(strategiesMap).reduce((supportedMethodTypes, currStrategies) => {
        const supportedMethodTypesForStrategies = getAuthMethodTypesForStrategyArray(currStrategies);
        return supportedMethodTypes.concat(supportedMethodTypesForStrategies);
    }, []);
    return Array.from(new Set(authenticationMethodTypes));
}
/**
 * Get a flat list of all authentication method types supported by a list of strategies.
 */
export function getAuthMethodTypesForStrategyArray(strategies) {
    return strategies.map(getAuthMethodTypesForStrategy).flat();
}
/**
 * Returns a list of authentication method types belonging to the given strategy.
 */
export function getAuthMethodTypesForStrategy(strategy) {
    var _a;
    return ((_a = STRATEGIES.find((record) => record.strategy === strategy)) === null || _a === void 0 ? void 0 : _a.types) || [];
}
